import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';

interface UserNameDisplay {
    ID?: number;
    userName?: string;
    userEmail?: string;
    userPicture?: string;
}

interface UserNameItemProps {
    user: UserNameDisplay;
    setShowUserCard?: ((userId: number) => void) | null;
    /** Компактний вигляд: менший аватар, лише ім'я */
    smallMode?: boolean;
}

const UserNameItem = ({
    user,
    setShowUserCard = null,
    smallMode = false,
}: UserNameItemProps) => {
    const [src, setSrc] = useState(user?.userPicture || '/imgs/user.png');

    useEffect(() => {
        setSrc(user?.userPicture || '/imgs/user.png');
    }, [user?.userPicture]);

    return (
        <Row
            className={[
                'w-100 m-0 flex-nowrap align-items-center',
                smallMode ? 'user-name-item--small' : undefined,
            ]
                .filter(Boolean)
                .join(' ')}
        >
            <Col className="px-0 flex-shrink-0" xs="auto">
                <img
                    className={[
                        'awatar awatar-user rounded-circle',
                        smallMode ? 'awatar--small' : undefined,
                    ]
                        .filter(Boolean)
                        .join(' ')}
                    src={src}
                    alt=""
                    onError={() => {
                        setSrc('/imgs/user.png');
                    }}
                />
            </Col>
            <Col className="min-w-0 overflow-hidden">
                <div
                    className={`${setShowUserCard ? 'cursor-pointer' : ''} text-truncate`}
                    onClick={() => (setShowUserCard && user.ID ? setShowUserCard(user.ID) : null)}
                >
                    <h6
                        className={[
                            'text-truncate',
                            smallMode ? 'mb-0 user-name-item__name--small' : 'mb-1',
                        ].join(' ')}
                        title={user?.userName || user?.userEmail}
                    >
                        {user?.userName}
                    </h6>
                    {!smallMode ? (
                        <p className="text-muted f-12 mb-0 text-truncate" title={user?.userEmail}>
                            {user?.userEmail}
                        </p>
                    ) : null}
                </div>
            </Col>
        </Row>
    );
};

export default UserNameItem;
